(function() {
  var headers = document.getElementsByClassName('js-site-header');

  for (var i = 0; i < headers.length; i++) {
    initHeader(headers[i]);
  }

  function initHeader(header) {
    var mobileTrigger = header.getElementsByClassName('js-site-header__nav-control')[0];
    var mobileNav = header.getElementsByClassName('js-site-header__mobile-nav')[0];
    var desktopToggles = header.getElementsByClassName('js-site-header__submenu-toggle');
    var mobileToggles = header.getElementsByClassName('js-site-header__mobile-submenu-toggle');
    var desktopQuery = window.matchMedia('(min-width: 80rem)');
    var adminBar = document.getElementById('wpadminbar');
    var preheader = document.getElementsByClassName('js-pre-header')[0];

    initSectionNavigation(header, mobileTrigger);
    updateHeaderOffset(header, adminBar, preheader);
    updateHeaderCapture(header, preheader);
    observeHeaderOffsets(header, adminBar, preheader);

    if (mobileTrigger && mobileNav) {
      mobileTrigger.addEventListener('anim-menu-btn-clicked', function(event) {
        toggleMobileMenu(header, mobileTrigger, mobileNav, event.detail);
      });
    }

    for (var i = 0; i < desktopToggles.length; i++) {
      initDesktopToggle(header, desktopToggles[i]);
    }

    for (var j = 0; j < mobileToggles.length; j++) {
      initMobileToggle(mobileToggles[j]);
    }

    header.addEventListener('focusout', function(event) {
      if (!desktopQuery.matches || header.contains(event.relatedTarget)) return;
      closeDesktopSubmenus(header);
    });

    header.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      closeDesktopSubmenus(header);
      if (mobileTrigger && mobileTrigger.getAttribute('aria-expanded') === 'true') {
        mobileTrigger.click();
        mobileTrigger.focus();
      }
    });

    document.addEventListener('pointerdown', function(event) {
      if (!header.contains(event.target)) closeDesktopSubmenus(header);
    });

    window.addEventListener('scroll', function() {
      closeDesktopSubmenus(header);
      updateHeaderOffset(header, adminBar, preheader);
      updateHeaderCapture(header, preheader);
    }, {passive: true});

    window.addEventListener('resize', function() {
      updateHeaderOffset(header, adminBar, preheader);
      updateHeaderCapture(header, preheader);
    });

    desktopQuery.addEventListener('change', function(event) {
      closeDesktopSubmenus(header);
      if (event.matches && mobileTrigger && mobileTrigger.getAttribute('aria-expanded') === 'true') {
        mobileTrigger.click();
      }
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', function() {
        updateHeaderOffset(header, adminBar, preheader);
      });
      window.visualViewport.addEventListener('resize', function() {
        updateHeaderOffset(header, adminBar, preheader);
      });
    }
  }

  function initDesktopToggle(header, toggle) {
    toggle.addEventListener('click', function() {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closeDesktopSubmenus(header);
      } else {
        openDesktopSubmenu(header, toggle);
      }
    });
  }

  function initSectionNavigation(header, mobileTrigger) {
    var navLinks = header.querySelectorAll('.js-site-header__nav-link, .site-header__service-link');
    var sectionGroups = [];
    var sectionIds = [];
    var frameRequested = false;

    for (var i = 0; i < navLinks.length; i++) {
      var sectionId = getLinkedSectionId(navLinks[i]);
      if (!sectionId) continue;

      var section = document.getElementById(sectionId);
      if (!section) continue;

      var groupIndex = sectionIds.indexOf(sectionId);
      if (groupIndex === -1) {
        sectionIds.push(sectionId);
        sectionGroups.push({id: sectionId, section: section, links: []});
        groupIndex = sectionGroups.length - 1;
      }

      sectionGroups[groupIndex].links.push(navLinks[i]);
    }

    for (var j = 0; j < navLinks.length; j++) {
      navLinks[j].addEventListener('click', function() {
        if (mobileTrigger && mobileTrigger.getAttribute('aria-expanded') === 'true') {
          mobileTrigger.click();
        }
      });
    }

    if (sectionGroups.length === 0) return;

    sectionGroups.sort(function(a, b) {
      return a.section.offsetTop - b.section.offsetTop;
    });

    function requestUpdate() {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(function() {
        updateActiveSection(header, sectionGroups);
        frameRequested = false;
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(requestUpdate, {
        rootMargin: '-20% 0px -65% 0px',
        threshold: [0, 0.01]
      });

      for (var k = 0; k < sectionGroups.length; k++) {
        observer.observe(sectionGroups[k].section);
      }
    }

    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  function getLinkedSectionId(link) {
    var href = link.getAttribute('href');
    var url;

    if (!href || href === '#') return '';

    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return '';
    }

    if (url.origin !== window.location.origin) return '';

    if (url.hash && url.hash.length > 1 && normalizePath(url.pathname) === normalizePath(window.location.pathname)) {
      return decodeURIComponent(url.hash.slice(1));
    }

    if (!url.hash) {
      var pathParts = normalizePath(url.pathname).split('/').filter(Boolean);
      return pathParts.length ? decodeURIComponent(pathParts[pathParts.length - 1]) : '';
    }

    return '';
  }

  function normalizePath(path) {
    var normalized = path.replace(/\/+$/, '');
    return normalized || '/';
  }

  function updateActiveSection(header, sectionGroups) {
    var headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
    var focusLine = Math.max(headerBottom + 24, window.innerHeight * 0.35);
    var activeGroup = null;

    for (var i = 0; i < sectionGroups.length; i++) {
      var sectionRect = sectionGroups[i].section.getBoundingClientRect();
      if (sectionRect.top <= focusLine && sectionRect.bottom > focusLine) {
        activeGroup = sectionGroups[i];
        break;
      }

      if (sectionRect.top > focusLine) {
        break;
      }
    }

    var activeLinks = header.getElementsByClassName('site-header__nav-link--section-active');
    while (activeLinks.length) {
      var activeLink = activeLinks[0];
      activeLink.classList.remove('site-header__nav-link--section-active');
      if (activeLink.getAttribute('aria-current') === 'location') activeLink.removeAttribute('aria-current');
    }

    if (!activeGroup) return;

    for (var j = 0; j < activeGroup.links.length; j++) {
      setSectionLinkActive(activeGroup.links[j]);

      var parentId = activeGroup.links[j].getAttribute('data-nav-parent-id');
      if (!parentId) continue;

      var parentLinks = header.querySelectorAll('[data-nav-item-id="' + parentId + '"]');
      for (var k = 0; k < parentLinks.length; k++) {
        setSectionLinkActive(parentLinks[k]);
      }
    }
  }

  function setSectionLinkActive(link) {
    link.classList.add('site-header__nav-link--section-active');
    if (!link.hasAttribute('aria-current')) link.setAttribute('aria-current', 'location');
  }

  function openDesktopSubmenu(header, toggle) {
    var submenuId = toggle.getAttribute('data-submenu');
    var submenu = document.getElementById(submenuId);
    if (!submenu) return;

    closeDesktopSubmenus(header, toggle);
    window.clearTimeout(header.siteHeaderSubmenuTimer);
    window.clearTimeout(submenu.siteHeaderHideTimer);
    submenu.hidden = false;
    submenu.offsetHeight;
    submenu.classList.add('site-header__submenu--open');
    toggle.setAttribute('aria-expanded', 'true');
    header.classList.add('site-header--submenu-open');
  }

  function closeDesktopSubmenus(header, exceptToggle) {
    var toggles = header.getElementsByClassName('js-site-header__submenu-toggle');
    var hasOpenSubmenu = false;
    var hasClosingSubmenu = false;

    for (var i = 0; i < toggles.length; i++) {
      if (exceptToggle && toggles[i] === exceptToggle) {
        hasOpenSubmenu = toggles[i].getAttribute('aria-expanded') === 'true';
        continue;
      }

      var submenu = document.getElementById(toggles[i].getAttribute('data-submenu'));
      toggles[i].setAttribute('aria-expanded', 'false');
      if (submenu && submenu.classList.contains('site-header__submenu--open')) {
        hideDesktopSubmenu(submenu);
        hasClosingSubmenu = true;
      }
    }

    if (!hasOpenSubmenu) {
      window.clearTimeout(header.siteHeaderSubmenuTimer);

      if (hasClosingSubmenu && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        header.siteHeaderSubmenuTimer = window.setTimeout(function() {
          header.classList.remove('site-header--submenu-open');
        }, 400);
      } else {
        header.classList.remove('site-header--submenu-open');
      }
    }
  }

  function hideDesktopSubmenu(submenu) {
    window.clearTimeout(submenu.siteHeaderHideTimer);
    submenu.classList.remove('site-header__submenu--open');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      submenu.hidden = true;
      return;
    }

    submenu.siteHeaderHideTimer = window.setTimeout(function() {
      submenu.hidden = true;
    }, 400);
  }

  function initMobileToggle(toggle) {
    toggle.addEventListener('click', function() {
      var submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!submenu) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      submenu.hidden = expanded;
    });
  }

  function toggleMobileMenu(header, trigger, nav, expanded) {
    header.classList.toggle('site-header--menu-open', expanded);
    document.documentElement.classList.toggle('site-header-menu-open', expanded);
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    nav.setAttribute('aria-hidden', expanded ? 'false' : 'true');

    if (!expanded) {
      var toggles = nav.getElementsByClassName('js-site-header__mobile-submenu-toggle');
      for (var i = 0; i < toggles.length; i++) {
        var submenu = document.getElementById(toggles[i].getAttribute('aria-controls'));
        toggles[i].setAttribute('aria-expanded', 'false');
        if (submenu) submenu.hidden = true;
      }
    }
  }

  function observeHeaderOffsets(header, adminBar, preheader) {
    if (preheader && window.MutationObserver) {
      var preheaderObserver = new MutationObserver(function() {
        updateHeaderOffset(header, adminBar, preheader);
      });

      preheaderObserver.observe(preheader, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style']
      });
    }

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function() {
        updateHeaderOffset(header, adminBar, preheader);
      });

      if (adminBar) resizeObserver.observe(adminBar);
      if (preheader) resizeObserver.observe(preheader);
    }
  }

  function updateHeaderOffset(header, adminBar, preheader) {
    if (!adminBar && !preheader) {
      header.style.removeProperty('--site-header-top-offset');
      return;
    }

    var adminBarBottom = getVisibleBottom(adminBar);
    var preheaderBottom = getVisibleBottom(preheader);
    var offset = Math.max(adminBarBottom, preheaderBottom);
    header.style.setProperty('--site-header-top-offset', offset + 'px');
  }

  function updateHeaderCapture(header, preheader) {
    var captureOffset = preheader ? Math.max(24, preheader.offsetHeight) : 24;
    header.classList.toggle('site-header--captured', window.scrollY > captureOffset);
  }

  function getVisibleBottom(element) {
    if (!element || window.getComputedStyle(element).display === 'none') return 0;
    return Math.max(0, element.getBoundingClientRect().bottom);
  }
}());
